const template = `<toggle-btn v-model="nightMode" @change="changNightMode"></toggle-btn>`;

export default {
	template,
	data() {
		return {
			nightMode: null
		};
	},
	methods: {
		changNightMode() {
			let theme = this.nightMode ? 'silver-dark' : 'silver';
			this.app.setTheme(theme);
		}
	},
	mounted() {
		//TODO: refactor
		this.$nextTick(() => {
			this.nightMode = (this.app.theme === 'silver-dark');
		});
	}
};